<div class="surface-card p-3 shadow-2 border-round rt-summary">
  Checked {{resourceCount}} resources against {{holderCount}} {{holderLabel}}.
  @if (wrongCount == 0) {
    <span class="rt-ok"><i class="pi pi-check-circle"></i> Every copy matches.</span>
  }
  @if (wrongCount > 0) {
    <span class="rt-bad"><i class="pi pi-exclamation-triangle"></i> {{wrongCount}} wrong {{wrongCount == 1 ? 'copy' : 'copies'}} of {{wrongResourceCount}} {{wrongResourceCount == 1 ? 'resource' : 'resources'}}.</span>
  }

  <label class="rt-switch">
    <input type="checkbox" [(ngModel)]="showMatching" (change)="build()"> Show matching copies
  </label>
</div>

@if (shown.length > 0) {
  <div class="surface-card p-3 shadow-2 border-round">
    <table class="rt-copies rt-results">
      <colgroup>
      <col style="width: 18%">
      <col style="width: 7%">
      <col style="width: 22%">
      <col>
        <col style="width: 7%">
        <col style="width: 6%">
      </colgroup>
      <tr>
        <th>Resource</th>
        <th>Uses</th>
        <th>Held in</th>
        <th>Where</th>
        <th>Stored</th>
        <th></th>
      </tr>
      @for (s of shown; track trackKey($index, s)) {
        <tr [class.rt-row-bad]="!s.row.copy.correct" [class.rt-group-start]="s.firstOfResource">
          <td>
            @if (s.firstOfResource) {
              <b>{{s.row.resource.name}}</b>
              @if (s.row.resource.disabled) {
                <span class="rt-dim"> (disabled)</span>
              }
            }
          </td>
          <td>@if (s.firstOfResource) {
            <b>{{s.row.resource.concurrentUses}}</b>
          }</td>
          <td>
            <span class="rt-kind">{{s.row.holder.kind}}</span>
            {{s.row.holder.name}}
            @if (s.row.holder.disabled) {
              <span class="rt-dim"> (disabled)</span>
            }
          </td>
          <td>{{s.row.copy.trail.slice(1).join(' › ')}}<div class="rt-dim rt-path">{{s.row.copy.valuePath}}</div></td>
          <td>{{s.row.copy.stored ?? '(missing)'}} @if (s.row.copy.correct) {
            <i class="pi pi-check rt-ok"></i>
          }</td>
          <td><button type="button" class="rt-json-btn" (click)="toggle(s)">{{opened.has(s.key) ? 'Hide' : 'JSON'}}</button></td>
        </tr>
        @if (opened.has(s.key)) {
          <tr class="rt-json-row">
            <td colspan="6">
              <div class="rt-json">
                <app-json-node [value]="s.row.holder.data" [notes]="opened.get(s.key).notes" [good]="opened.get(s.key).good" [expand]="opened.get(s.key).expand"></app-json-node>
              </div>
            </td>
          </tr>
        }
      }
    </table>
  </div>
}
